export const dbName = 'dt_trainDb';
export const trainsTableName = 'trains';
export const trainsTableKeyPath = 'trainNumber';
export const trainsMetaDataTableName = 'trains_meta_data';
export const trainsMetaDataTableKeyPath = 'createdAt';
export const checisTableName = 'checis';
export const version = 1;
export const trainsFullInfoMapFileName = 'trainsFullInfoMap.json';
